import http from '@/utils/http/index';
import { formatDateDisplay } from '@/utils/tools/time.js';

// 首页查询拒付交易及成功率
export function getChargebackStatistics(params) {
  return http.get('/merchantIndex/chargebackStatistics');
}

// 拒付提示信息
export function getChargebackList() {
  return http.get('/merchantIndex/chargebackPending');
}

// 检查是否有权限
export function checkPermission(code) {
  return http.get(`/merPermissions/check?code=${code}`);
}

// 交易成功率
export function getTxnSuccessRate() {
  return http.get('/merchantIndex/successRate');
}

// 交易统计币种列表
export function getCurrencyList(params) {
  return http.get('/merchantIndex/showCurrency', { params });
}

/**
 *
 * @param {*} params {dayCount, currency, type[0-交易, 1-拒付]}
 * @returns
 */
export function getTxnStatistics(params) {
  return http.get('/merchantIndex/successCount', { params });
}

export async function getWeekTxnStatistics(params) {
  const res = await http.get('/merchantIndex/successCountByWeek', { params });
  const obj = {};
  Object.keys(res).forEach(k => {
    const stime = new Date(k).getTime();
    const etime = stime + 6 * 24 * 60 * 60 * 1000; // 加上 6 天
    const key = `${formatDateDisplay(stime, 'yyyy.MM.dd')}~${formatDateDisplay(etime, 'yyyy.MM.dd')}`;
    obj[key] = res[k];
  });
  return obj;
}

export async function getMonthTxnStatistics(params) {
  const res = await http.get('/merchantIndex/successCountByMonth', { params });
  const obj = {};
  Object.keys(res).forEach(k => {
    const key = formatDateDisplay(k, 'yyyy.MM');
    obj[key] = res[k];
  });
  return obj;
}

// 当日交易成功率
export function getTodayTxnSuccessRate() {
  return http.get('/merchantIndex/successRateByToday');
}

// 商户统计信息
export function getMerchantStatistics() {
  return http.get('/merchantIndex/queryMerchantStatistics');
}

export function getSuccessCountNotIncludeToday(params) {
  return http.get('/merchantIndex/showSuccessCountNotIncludeToday', { params });
}

export function getSuccessRateNotIncludeToday() {
  return http.get('/merchantIndex/showSuccessRateNotIncludeToday');
}

// 商户统计昨日信息
export function getMerchantStatisticsYesterday() {
  return http.get('/merchantIndex/queryMerchantStatisticsYesterday');
}

// 获取拒付率/退款率币种列表
export function getRefuseCurrencyList() {
  return http.get('/merchantIndex/currency');
}

// 获取汇率数据（拒付率、退款率）
export async function getRateInfoData(params = {}) {
  const res = await http.get('/merchantIndex/rateOption', { params });
  const data = res.reduce((acc, cur) => {
    acc[cur.createdDate] = {
      ...cur,
      amount: +cur.amount,
      count: +cur.count,
      rate: +cur.rate,
    };
    return acc;
  }, {});
  return data;
}

export function queryStatAccountMoneyTotal(params = {}) {
  return http.get('/merchantIndex/statAccountMoneyTotal', { params });
}
